/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type OffenseOrderInfoDto = {
    /**
     * Eshop order identifier. Type: "UUID"
     */
    eshopOrderId?: string;
    /**
     * Eshop order payment type
     */
    eshopOrderPaymentType?: OffenseOrderInfoDto.eshopOrderPaymentType;
    /**
     * Eshop order state
     */
    eshopOrderState?: OffenseOrderInfoDto.eshopOrderState;
    /**
     * System order identifier. Type: "UUID"
     */
    orderId?: string;
    /**
     * System order payment type
     */
    counterOrderPaymentType?: OffenseOrderInfoDto.counterOrderPaymentType;
    /**
     * Is counter order paid
     */
    counterOrderPaid?: boolean;
};
export namespace OffenseOrderInfoDto {
    /**
     * Eshop order payment type
     */
    export enum eshopOrderPaymentType {
        CASH = 'CASH',
        BANK_CARD = 'BANK_CARD',
        ELECTRONIC_WALLET = 'ELECTRONIC_WALLET',
        INVOICE = 'INVOICE',
    }
    /**
     * Eshop order state
     */
    export enum eshopOrderState {
        PENDING = 'PENDING',
        PAID = 'PAID',
        CANCELLED = 'CANCELLED',
        REJECTED = 'REJECTED',
        RETURNED = 'RETURNED',
        PROCESSING = 'PROCESSING',
    }
    /**
     * System order payment type
     */
    export enum counterOrderPaymentType {
        CASH = 'CASH',
        BANK_CARD = 'BANK_CARD',
        ELECTRONIC_WALLET = 'ELECTRONIC_WALLET',
        INVOICE = 'INVOICE',
    }
}

